export default __webpack_public_path__ + "static/media/aleksandr.8209c3e8.webp";